import React from 'react';
import { BsTwitter, BsLinkedin, BsGithub } from 'react-icons/bs';


const SocialMedia = () => {
  return (
    <div className="app__social">
      <div>
       <a href='https://twitter.com/MarpelHephezy' target='_blank' rel="noreferrer">
        <BsTwitter />
       </a>
      </div>
      <div>
       <a href='https://github.com/Hephezy' target='_blank' rel="noreferrer">
        <BsGithub />
       </a>
      </div>
      <div>
       <a href='https://linkedin.com/in/pelumi-martins3' target='_blank' rel="noreferrer">
        <BsLinkedin />
       </a>
      </div>
    </div>
  );
}

export default SocialMedia